import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

// Pages & Components
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import Packages from "./pages/Pricing";
import Contact from "./pages/Contact";


import Preloader from './components/Preloader';
import { ImageProvider } from './context/ImageContext';

// Quotation Pages
import Quotation from "./Quotation/Quotation";
import Qdashboard from "./Quotation/Qdashboard";
import QuotationMaker from "./Quotation/QuotationMaker";
import QuotationHistory from "./Quotation/QuotationHistory";
import Bookings from './Quotation/BookingCalendar';
import Login from "./pages/Login";
import PhotoAdmin from "./Quotation/PhotoAdmin";
import PackageAdmin from "./Quotation/PackageAdmin";
import ResetPassword from "./pages/ResetPassword";

function AppLayout() {
  const location = useLocation();

  // Hide Navbar/Footer on admin and quotation pages
  const isLogin = location.pathname.startsWith("/login");
  const isQuotation = location.pathname.startsWith("/dashboard");
  const isReset = location.pathname.startsWith("/reset-password");

  return (
    <>
      {!isLogin && !isReset && !isQuotation && <Navbar />}

      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/reset-password" element={<ResetPassword/>} />

        

        {/* Quotation system nested routing*/}
        <Route path="/dashboard" element={
            sessionStorage.getItem("user") ? <Quotation />: <Navigate to="/login" />}>

        {/*<Route path="/dashboard" element={<Quotation />}>*/}
          <Route index element={<Qdashboard />} />
          <Route path="maker" element={<QuotationMaker />} />
          <Route path="history" element={<QuotationHistory />} />
          <Route path="photo-admin" element={<PhotoAdmin/>} />
          <Route path="packages" element={<PackageAdmin/>} />
          <Route path="bookings" element={<Bookings/>}/>
        </Route>
      </Routes>

      {!isLogin && !isReset && !isQuotation && <Footer />}
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ImageProvider>
      <Router>
        {loading ? <Preloader /> : <AppLayout />}
      </Router>
    </ImageProvider>
  );
}

export default App;
